import {
    Action,
    Namespace,
    StoreName,
    StoreProps
} from '../../../services/proto/ServerStorage/utils';

export const keyParams: StoreProps = {
    nameSpace: Namespace.System,
    action: Action.Onload,
    storage: StoreName.Announcements,
    hasWildcard: false
};
